import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { BlueprintDeployment } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";

import DeploymentStateBadge from "../../StateBadge";

const TemplateDeploymentsStatusCell = ({
  item: deployment,
  ...cellProps
}: TableSimpleCellProps<BlueprintDeployment>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <DeploymentStateBadge state={deployment.state} />
    </TableSimpleCell>
  );
};

export default TemplateDeploymentsStatusCell;
